<template>
  <div>
    <v-app v-if="!is_authenticated">
      <router-view></router-view>
    </v-app>
    <v-app v-if="is_authenticated">
      <v-app-bar height="56" elevation="0" app color="transparent" class="dct-appbar">
        <div class="d-flex align-center">
          <div class="dct-logo">DCT</div>
          <div class="d-flex flex-column ml-3" style="line-height: 1.15">
            <span class="font-weight-bold" style="font-size: 14px">
              Domain Collector
            </span>
            <span style="font-size: 11px; opacity: 0.55">
              Collecting parameters by domains
            </span>
          </div>
        </div>

        <v-spacer></v-spacer>

        <div
          v-if="limits.month_limit"
          class="d-none d-md-flex align-center mr-2"
          style="gap: 20px"
        >
          <div
            class="dct-meter"
            :title="
              `Monthly limit: ${fullNumber(limits.month_used)} / ${fullNumber(
                limits.month_limit
              )}`
            "
          >
            <div class="dct-meter__row">
              <span style="opacity: 0.55">Monthly</span>
              <span class="font-weight-medium">
                {{ compactNumber(limits.month_used) }} /
                {{ compactNumber(limits.month_limit) }}
              </span>
            </div>
            <v-progress-linear
              :value="pct(limits.month_used, limits.month_limit)"
              height="4"
              rounded
              color="info"
              background-color="grey lighten-2"
              class="mt-1"
            ></v-progress-linear>
          </div>

          <div
            v-if="limits.ahrefs_api"
            class="dct-meter"
            :title="
              `Ahrefs API units: ${fullNumber(
                limits.ahrefs_api.units_usage_api_key
              )} / ${fullNumber(limits.ahrefs_api.units_limit_api_key)}`
            "
          >
            <div class="dct-meter__row">
              <span class="error--text" style="opacity: 0.85">Ahrefs API</span>
              <span class="font-weight-medium">
                {{ compactNumber(limits.ahrefs_api.units_usage_api_key) }} /
                {{ compactNumber(limits.ahrefs_api.units_limit_api_key) }}
              </span>
            </div>
            <v-progress-linear
              :value="
                pct(
                  limits.ahrefs_api.units_usage_api_key,
                  limits.ahrefs_api.units_limit_api_key
                )
              "
              height="4"
              rounded
              color="error"
              background-color="red lighten-4"
              class="mt-1"
            ></v-progress-linear>
          </div>

          <v-divider
            vertical
            class="mx-1"
            style="height: 24px; align-self: center"
          ></v-divider>
        </div>

        <v-btn @click="toggle_dark_mode" icon>
          <v-icon>mdi-desk-lamp</v-icon>
        </v-btn>

        <v-menu
          v-model="menu_bug"
          :close-on-content-click="false"
          :nudge-width="500"
          offset-y
          offset-x
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-bug</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              Bug form
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-textarea
                  v-model="msg_bug"
                  :rules="bugRules"
                  solo
                  name="input-7-4"
                  label="What's your problem?"
                ></v-textarea>
              </v-form>
              <small
                >Want to attach a screenshot? Use
                <a href="http://joxi.net/download/" target="_blank"
                  >joxi</a
                ></small
              >
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="send_bug_form"
                :loading="bug_loading"
              >
                Send
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

        <v-menu
          bottom
          left
          transition="slide-x-transition"
          content-class="custom-menu"
          :close-on-content-click="false"
          rounded="lg"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list dense nav>
            <v-list-item @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-app-bar>

      <v-main>
        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "App",

  data: () => ({
    interface_settings: {},
    menu_bug: false,
    bug_loading: false,
    msg_bug: undefined,
    valid: false,
    limits: {},
    bugRules: [
      v => !!v || "Description is required",
      v =>
        (v && v.trim().length >= 10) ||
        "Description must be more than 10 characters"
    ]
  }),
  methods: {
    fetch_limits() {
      let url = `${this.$store.state.server_url_clear}/api/dct/limits`;

      axios
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.$store.state.auth.token
          }
        })
        .then(response => {
          this.limits = response.data;
        })
        .catch(() => {});
    },
    compactNumber(value) {
      return new Intl.NumberFormat("en", {
        notation: "compact",
        maximumFractionDigits: 1
      }).format(Number(value) || 0);
    },
    fullNumber(value) {
      return Number(value || 0).toLocaleString("en-US");
    },
    pct(used, total) {
      return total ? (100 * (used || 0)) / total : 0;
    },
    logout() {
      let self = this;
      self.$store.dispatch("logout", function() {
        self.$router.push("/login");
      });
    },
    toggle_dark_mode() {
      this.interface_settings.dark_mode = !this.interface_settings.dark_mode;
      this.save_interface_settings();
    },
    save_interface_settings() {
      localStorage.setItem(
        "interface_settings",
        JSON.stringify(this.interface_settings)
      );
      this.$vuetify.theme.dark = this.interface_settings.dark_mode;
    },
    send_bug_form() {
      let self = this;

      if (false === self.$refs.form.validate()) {
        return;
      }

      self.bug_loading = true;

      let url = `${self.$store.state.server_url_clear}/api/dct/bug-form`;

      let post_data = {
        msg: self.msg_bug
      };

      let config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: self.$store.state.auth.token
        }
      };

      axios.post(url, post_data, config).finally(() => {
        self.bug_loading = false;
        self.menu_bug = false;
      });
    }
  },
  computed: {
    is_authenticated() {
      return this.$store.getters.isAuthenticated;
    }
  },
  watch: {
    is_authenticated(value) {
      if (value) {
        this.fetch_limits();
      }
    }
  },
  created() {
    document.title = "DCT: Collecting Parameters by Domains";
  },
  mounted() {
    if (this.is_authenticated) {
      this.fetch_limits();
    }

    if (localStorage.getItem("interface_settings")) {
      try {
        this.interface_settings = JSON.parse(
          localStorage.getItem("interface_settings")
        );
        this.$vuetify.theme.dark = this.interface_settings.dark_mode;
      } catch (e) {
        localStorage.removeItem("interface_settings");
      }
    }
  }
};
</script>
